import { deleteApiCaller, getApiCaller, postApiCaller, putApiCaller } from "../apiCaller";

// Get all home sections (with optional category filter)
export const getHomeSections = async (currentPage, itemsPerPage, search, categoryId = undefined) => {
    let url = `homeSection/get-all?page=${currentPage}&limit=${itemsPerPage}&search=${search}&includeHidden=true`;
    if (categoryId !== undefined) {
        url += `&categoryId=${categoryId}`;
    }
    const response = await getApiCaller(url);
    return response;
}

// Get home section by ID
export const getHomeSectionById = async (id) => {
    const response = await getApiCaller(`homeSection/${id}`);
    return response;
}

// Add home section
export const addHomeSection = async (payload) => {
    const response = await postApiCaller("homeSection/create", payload);
    return response;
}

// Update home section
export const updateHomeSection = async (id, payload) => {
    const response = await putApiCaller(`homeSection/${id}`, payload);
    return response;
}

// Delete home section
export const deleteHomeSection = async (id) => {
    const response = await deleteApiCaller(`homeSection/${id}`);
    return response;
}

// Update home section sequence
export const homeSectionSequence = async (payload) => {
    const response = await putApiCaller("homeSection/sequence", payload);
    return response;
}

// Swap home section with adjacent page
export const swapHomeSectionWithPage = async (payload) => {
    const response = await putApiCaller("homeSection/swap-page", payload);
    return response;
}
